<div class = "reusable-form-component">
    <ion-label *ngIf = "labelText" class = "label labelText">{{ labelText }}</ion-label>
    <button class="position select-font" (click) = "handleSubSkillDropDownClick()" [ngClass] = "{'placeholder' : placeHolderText == 'Select Sub Skill'}">{{ placeHolderText }}      
</button>
